import { axios } from "./axios";
import { client } from "./request";
import ProjectTemplateApi from "./project-template-api";

export const templateApi = new ProjectTemplateApi(client);

export function setToken(token: string) {
  axios.defaults.headers["Authorization"] = "Bearer " + token;
}

export function resetToken() {
  delete axios.defaults.headers["Authorization"];
}
